import { useState } from "react";
import Box from "@mui/material/Box";
import { ImagePlus, Replace } from "lucide-react";
import IconButton from "../../../components/Buttons/IconButton";
import UploadFileButton from "../../../components/Buttons/UploadFileButton";
import ModalMedia from "../../../components/Modal/ModalMedia";
import { IMAGE_FORMATS } from "../../../utils/constants";
import {
  TEMPLATES_PRODUCE_REPLACE_IMAGE,
  TEMPLATES_PRODUCE_SELECT_IMAGE,
} from "../../../i18n/keysTranslations";

const iconButtonSx = {
  width: 32,
  height: 32,
  color: "text.primary",
  "&:hover": { color: "text.primary" },
};

const ProduceImageCell = ({
  url = "",
  inputId,
  onChange = () => {},
  pathStorage = "",
  disabled = false,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const hasImage = Boolean(url);
  const isBusy = disabled || isUploading;

  const onOpenPicker = (event) => {
    event?.stopPropagation?.();
    if (isBusy) return;
    document.getElementById(inputId)?.click();
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {hasImage ? (
        <>
          <Box
            component="img"
            src={url}
            alt=""
            onClick={(event) => {
              event.stopPropagation();
              setIsPreviewOpen(true);
            }}
            sx={{
              width: 48,
              height: 48,
              objectFit: "cover",
              borderRadius: "8px",
              cursor: "pointer",
              flexShrink: 0,
              backgroundColor: "#EEE",
            }}
          />
          <IconButton
            tooltipText={TEMPLATES_PRODUCE_REPLACE_IMAGE}
            disabled={isBusy}
            loading={isUploading}
            onClick={onOpenPicker}
            sx={iconButtonSx}
          >
            <Replace size={16} />
          </IconButton>
        </>
      ) : (
        <IconButton
          tooltipText={TEMPLATES_PRODUCE_SELECT_IMAGE}
          disabled={isBusy}
          loading={isUploading}
          onClick={onOpenPicker}
          sx={iconButtonSx}
        >
          <ImagePlus size={18} />
        </IconButton>
      )}
      <UploadFileButton
        id={inputId}
        acceptedFormats={IMAGE_FORMATS}
        multiple={false}
        pathStorage={pathStorage}
        textUpload={TEMPLATES_PRODUCE_SELECT_IMAGE}
        colorUpload="secondary"
        isHidden={true}
        disabled={isBusy}
        onFileSelect={(files) => {
          if (files?.length) setIsUploading(true);
        }}
        onChange={(urls) => {
          const nextUrl = Array.isArray(urls) ? urls[0] : urls;
          if (nextUrl) onChange(nextUrl);
        }}
        onUploadSettled={() => setIsUploading(false)}
      />
      {isPreviewOpen ? (
        <ModalMedia
          modalOpen={isPreviewOpen}
          onCloseModal={() => setIsPreviewOpen(false)}
          url={url}
          showEditButton={false}
          showShareButton={false}
          showDeleteButton={false}
          isPicker={true}
        />
      ) : null}
    </Box>
  );
};

export default ProduceImageCell;
